import { DomHandler } from 'primeng/dom';

let patched = false;

export function ensurePrimeOverlayPatch(): void {
  if (patched || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  patched = true;

  const originalAbsolute = DomHandler.absolutePosition.bind(DomHandler);
  DomHandler.absolutePosition = (element: HTMLElement, target: HTMLElement, gutter = true) => {
    originalAbsolute(element, target, gutter);
    alignOverlay(element, target);
  };

  const originalRelative = DomHandler.relativePosition.bind(DomHandler);
  DomHandler.relativePosition = (element: HTMLElement, target: HTMLElement, gutter = true) => {
    originalRelative(element, target, gutter);
    alignOverlay(element, target);
  };
}

function alignOverlay(element: HTMLElement, target: HTMLElement | null): void {
  if (!target) {
    return;
  }

  const targetRect = target.getBoundingClientRect();
  const parent = element.offsetParent as HTMLElement | null;
  const parentRect = parent?.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;

  const top = parentRect
    ? targetRect.bottom - parentRect.top
    : targetRect.bottom + scrollTop;

  const left = parentRect
    ? targetRect.left - parentRect.left
    : targetRect.left + scrollLeft;

  element.style.position = 'absolute';
  element.style.top = `${top}px`;
  element.style.left = `${left}px`;
  element.style.minWidth = `${targetRect.width}px`;
  element.style.transformOrigin = 'top';
  element.style.visibility = 'visible';
}
